import "../index.css";

export default function Home() {
  return (
    <section id="home" className="home-section">
      {/* HERO */}
      <div
        className="hero"
        style={{ backgroundImage: `url(/images/port.jpeg)` }}
      >
        <div className="overlay"></div>

        <div className="hero-content">
          <h1>
            Gxpress <span>Solutions</span>
          </h1>

          <h3>Решения в области электроннойторговли и логистики</h3>

          <p>
            Gxpress Solutions —международнаялогистическая и экспедиторскаякомпания. Мы предоставляемкомплексную и надежнуюлогистическую поддержку дляпредприятий, работающих всферемеждународной торговлииэлектронной коммерции.
          </p>

          <p>
           Мы помогаем продавцам, производителям и корпоративнымклиентам эффективно и безопаснодоставлять товарычерез границы, следуя требованиямзаконодательства, чтобывысмоглисосредоточиться на развитиисвоегобизнеса. 
          </p>

          <div className="hero-buttons">
            <a href="#contact" className="btn-primary">Подать заявку</a>
            <a href="#about" className="btn-outline">Узнать больше</a>
          </div>
        </div>
      </div>

      {/* SERVICES STRIP */}
      <div className="services-highlight">
        <div className="service-text">
          <h2>Проверенный продавецикомплексная логистическаяподдержка</h2>
          <p>
           На всех этапах —от приематоварадоего конечной доставки —мыобеспечиваем полнуюпрозрачностьинадежность вашей поставкиповсемумиру.
          </p>
        </div>

        <div className="service-image">
          <img src="/images/plane.jpeg" alt="Air Freight" />
        </div>
      </div>
    </section>
  );
}